import React, { useState, useEffect} from 'react';
import './App.css';
import * as d3 from 'd3-dsv';
import * as geom from './geom';
import Scroll from './Scroll.js';

async function getCSV(url){
  const tempData = await fetch(url)
    .then(response => {
      return response.ok ? response.text() : Promise.reject(response.status);
    }).then(text => {
      let data = d3.csvParse(text, d3.autoType)
      
      return data
    })
  
    return tempData
}


function App() {
  const [index, setIndex] = useState(0)  
  const [showCredits, setShowCredits] = useState(false)
  const [currCity, setCurrCity] = useState('')
  const [timerId, setTimerId] = useState(null)
  const [dateList, setDateList] = useState([])
  const [sums, setSums] = useState([])


  useEffect(() => {
    if (!dateList.length){
      getCSV('https://raw.githubusercontent.com/GeoDaCenter/covid/master/public/csv/covid_deaths_nyt_state.csv').then(raw => {
        const reducer = (accumulator, currentValue) => accumulator + currentValue;
        const dailySummed = Object.keys(raw[0]).slice(2).map(date => raw.map(row => row[date]).reduce(reducer))
        const dates = Object.keys(raw[0]).slice(2).map(date => date)
        setDateList(dates)
        setSums(dailySummed)
      })
      document.getElementById('App').addEventListener('contextmenu', evt => evt.preventDefault());
    }
  }, [dateList, sums])

  useEffect(() => {
    if (index === dateList.length-1) {
      clearInterval(timerId);
      setTimerId(null);
    }
  },[index, timerId, dateList])
  
  const handleCity = (city) => {
    if (!currCity) {
      setCurrCity(city)
      // setTimerId(setInterval(() => { setIndex(i => i + 1 ) 
        // for (let n=i; n < dateList.length; n++){
        //   console.log(dateList[n].slice(0,7))
        //   if (dateList[n].slice(0,7) !== dateList[i].slice(0,7)) return n
        // }
        // return dateList.length-1
        // })
      // }, 250))
    }
  }

  const resetCity = () => {
    if (currCity) {
      setCurrCity('')
      clearInterval(timerId);
      setTimerId(null);
      setIndex(0)
    }
  }

  return (
    <div id="App">
      {!currCity && <div id="selectorWrapper">
        <div id="selector">
          <h1>All our US COVID deaths in</h1>
          {Object.keys(geom).map(key => <button className="locationButton" onClick={() => handleCity(key)}>{geom[key].name}</button>)}
        </div>
      </div>}
      {currCity && <Scroll city={currCity} sums={sums} index={index} return={resetCity} />}
      {currCity && <button id="reset" onClick={() => resetCity()}>return</button>}
      <div style={{fontFamily: 'WeePeople', opacity:0, pointerEvents:'none'}}>x</div>
      {!currCity && <button onClick={() => setShowCredits(prev => !prev)} id="credits">About &amp; Credits</button>}
      {showCredits && 
        <div id="aboutModal">
          <h1>All Our US COVID deaths</h1>
          <p>
            These maps attempt to place this loss in space, around parks and cities you might know or remember, from
            trips, growing up, or daily life. Remembering and facing the price of COVID-19 is not easy, but forgetting it may cost even more.
            <br/><br/>
            As of now, the state of the pandemic has improved through late January, February, and into early March. But this can change. Variants and
            our behavior are unknowns in planning for the recovery. 
            <br/><br/>
            Take care, remember those lost, and do what you can to protect and support your community. For more information on the pandemic, its impact,
            history, and the trajectory of the recovery, visit <a href="https://uscovidatlas.org/" target="blank" rel="noopener noreferrer">uscovidatlas.org</a>.
            <br/><br/>

            <b>Project Contributors</b><br/>
            Dylan Halpern <a href="https://twitter.com/dchalpern" name="link" target="blank" rel="noopener noreferrer">@dchalpern</a>
            <br/>
            Susan Paykin <a href="https://twitter.com/spaykin" name="link" target="blank" rel="noopener noreferrer">@spaykin</a>
            <br/><br/>

            <b>3D Models</b><br/>
            Ben Sauerwine (Chicago Bean) via <a href="https://www.thingiverse.com/bsauerwine/designs" name="link" target="blank" rel="noopener norefferer">Thingiverse</a><br/> 
            Monart (St Louis Arch) via <a href="https://www.cgtrader.com/monart" name="link" target="blank" rel="noopener norefferer">CGTrader</a>
            <br/><br/>

            <b>Typeface</b><br/>
            Wee People by <a href="https://github.com/propublica/weepeople" name="link" target="blank" rel="noopener norefferer">Propublica</a><br/>
            Typeface usage inspired by <a href="https://twitter.com/willy_maps" name="link" target="blank" rel="noopener norefferer"> William B. Davis</a>
            
            <br/><br/>

            <b>Data Credits</b><br/>
            OpenStreetMap Contributors<br/>
            City of Chicago Open Data<br/>

          </p>
          <button onClick={() => setShowCredits(prev => !prev)} id="close" title="close modal">×</button>
        </div>}

    </div>
  );
}

export default App;
